import { useCallback, useMemo } from 'react';
import { adminApi } from '../../services/adminApi';
import AdminGrid from '../../components/admin/AdminGrid';

export default function Usage() {
  const columns = useMemo(() => [
    { field: 'firstName', headerName: 'Name' },
    { field: 'email', headerName: 'Email', minWidth: 200 },
    { field: 'companyId', headerName: 'Company ID' },
    { field: 'tokenUsed', headerName: 'Tokens Used', filter: 'agNumberColumnFilter' },
    { field: 'apiUsed', headerName: 'API Used', filter: 'agNumberColumnFilter' },
    { field: 'reportCreated', headerName: 'Reports Created', filter: 'agNumberColumnFilter' },
    { field: 'premiumReports', headerName: 'Premium Reports', filter: 'agNumberColumnFilter' },
    { field: 'autoRefreshCount', headerName: 'Auto Refresh', filter: 'agNumberColumnFilter' },
  ], []);

  const fetchData = useCallback(async () => {
    const res = await adminApi.getUsage({ page: 0, size: 10000 });
    return res.content || [];
  }, []);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-100 mb-4">Usage</h1>
      <AdminGrid columns={columns} fetchData={fetchData} />
    </div>
  );
}
